import { render, staticRenderFns } from "./project-add.vue?vue&type=template&id=94d10234&scoped=true&"
import script from "./project-add.vue?vue&type=script&lang=js&"
export * from "./project-add.vue?vue&type=script&lang=js&"
import style0 from "./project-add.vue?vue&type=style&index=0&id=94d10234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d10234",
  null
  
)

export default component.exports